import {
    faCalendar,
    faCheckCircle,
    faCircle,
    faEdit,
    faFile,
    faFilePdf,
    faFlag,
} from "@fortawesome/free-regular-svg-icons";

export const far = {
    faCalendar,
    faCheckCircle,
    faCircle,
    faEdit,
    faFile,
    faFilePdf,
    faFlag,
};
